console.log('test 11.04');
import { lazyLoadInstance } from '../libs/lazyLoad';
import { Swiper, Navigation, Pagination } from 'swiper';

const modalBtnsClass = 'js-modal-media-btn-new';
const modalCloseBtnClass = 'js-modal-media-btn-close';
// const loadingClass = 'is-loading';
const activeClass = 'is-active';

document.addEventListener('click', (event) => {
	const target = event.target.closest(`.${modalBtnsClass}, .${modalCloseBtnClass}`);
	if (!target) return;

	if (target.classList.contains(modalBtnsClass)) {
		event.preventDefault();
		const galleryBlock = target.closest('[data-block="gallery"]');
		const galleryId = galleryBlock.dataset.galleryId;
		openModal(galleryId);
		initSlider(galleryId);
	}
	if (target.classList.contains(modalCloseBtnClass)) {
		event.preventDefault();
		const modal = target.closest('.js-modal-media');
		closeModal(modal);
	}
});

function openModal(galleryId) {
	const modal = document.querySelector(`.js-modal-media[data-gallery-id="${galleryId}"]`);
	modal.classList.add(activeClass);
}

function closeModal(modal) {
	modal.classList.remove(activeClass);
}

function initSlider(galleryId) {
	const sliderGalleryHld = document.querySelector(`.js-modal-media[data-gallery-id="${galleryId}"] .js-modal-media-gallery-swiper-new`);
	const sliderGallery = new Swiper(sliderGalleryHld, {
		modules: [Navigation, Pagination],
		slidesPerView: 1,
		loop: false,
		grabCursor: true,
		navigation: {
			prevEl: `.js-modal-media[data-gallery-id="${galleryId}"] .js-modal-media-gallery-swiper-new-prev`,
			nextEl: `.js-modal-media[data-gallery-id="${galleryId}"] .js-modal-media-gallery-swiper-new-next`,
		},
		pagination: {
			el: `.js-modal-media[data-gallery-id="${galleryId}"] .js-modal-media-gallery-swiper-new-pagination`,
			type: 'fraction',
		},
		breakpoints: {
			1024: {
				allowTouchMove: false,
			},
		},
		on: {
			slideChange: function() {
				lazyLoadInstance.update();
			},
		},
	});
	sliderGallery.init();
}
